module.exports = __webpack_public_path__ + "img/info-time.16012d14.svg";